/* template */
<template><div class="worry-free-cancellation-bar"><mpx-view @tap="openServiceDesc" class="title-info"><div class="title">退改无忧</div><Icon size="20" color="#999" name="circle-question-mark" class="circle-question-mark" v-if="(!timing)"/><div class="detail" v-else>详情<Icon size="16" color="#999" name="right-thin-arrow" class="right-thin-arrow"/></div></mpx-view><div :class="({order: timing})" class="service-status"><Icon size="24" color="#00A442" name="checkmark-circle" class="checkmark-circle" v-if="(timing)"/><div class="status-text">{{ statusText }}</div></div></div></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m096bd8e2"}'>
  .worry-free-cancellation-bar
    display flex
    justify-content space-between
    align-items center
    box-sizing border-box
    padding 16px 14px
    background #fff
    margin-bottom 9.5px
    border-radius 8px
    .title-info
      display flex
      align-items center
      .title
        font-size 16px
        color #333
        font-family PingFangSC-Semibold
        font-weight 600
      .circle-question-mark
        margin-left 4px
      .detail
        display flex
        align-items center
        color #999
        font-size 14px
        margin-left 6px
        .right-thin-arrow
          margin-left 4.5px
    .service-status
      display flex
      align-items center
      font-size 14px
      color #999
      font-family PingFangSC-Medium
      font-weight 500
      .checkmark-circle
        margin-right 2px
      &.order
        color #00A442
        font-size 12px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m096bd8e2"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./worry-free-cancellation-bar.mpx.js?isComponent&outputPath=components%2Fworry-free-cancellation-bar096bd8e2%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./worry-free-cancellation-bar.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fworry-free-cancellation-bar096bd8e2%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m096bd8e2"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/worry-free-cancellation-bar096bd8e2/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'Icon':getComponent(require("../../node_modules/@didi/spring-icon/index/index.mpx?isComponent&outputPath=components%2Findex4d1d0d54%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
